import { render } from "./specificArchive.vue?vue&type=template&id=1193a56e"
import script from "./specificArchive.vue?vue&type=script&lang=js"
export * from "./specificArchive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__